import { FC, PropsWithChildren } from "react";
import clsx from "clsx";

interface BaseProps extends PropsWithChildren {
  type: "INFO" | "ERROR";
}

function Base({ children, type }: BaseProps) {
  return (
    <div
      className={clsx("p-2 leading-5 text-center text-sm font-medium border border-solid rounded-sm print:hidden", {
        "bg-blue-100 text-platform-600 border-platform-600": type === "INFO",
        "bg-red-100 text-red-600 border-red-600": type === "ERROR",
      })}
    >
      {children}
    </div>
  );
}

function Info(props: PropsWithChildren) {
  return <Base {...props} type="INFO" />;
}

function Error(props: PropsWithChildren) {
  return <Base {...props} type="ERROR" />;
}

interface WarningProps {
  onClickClose?: () => void;
  additionalClassName?: string;
}

export const Warning: FC<PropsWithChildren<WarningProps>> = ({ children, onClickClose, additionalClassName }) => (
  <div
    className={clsx("bg-amber-500", "rounded-sm", "border-amber-500", "border", "border-solid", additionalClassName)}
  >
    <div className="flex justify-between p-2 ml-2 text-sm font-medium leading-5 rounded-r bg-amber-50 text-neutral-800">
      <div className="flex items-center gap-2">
        <i className="text-lg icon icon-lt-alert-line text-amber-500"></i>
        <div>{children}</div>
      </div>

      {onClickClose && (
        <div>
          <button onClick={() => onClickClose()} className="p-0 bg-transparent border-none cursor-pointer">
            <i className="pl-2 text-lg icon-lt-close-line text-neutral-800" />
          </button>
        </div>
      )}
    </div>
  </div>
);

export const Alert = {
  Info,
  Error,
  Warning,
};
